import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { getMOMSSListDataByOrderServiceOrderId } from '../orderMSServices/mockData'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getOrderServiceOrderListData,
  propagateOrderServiceOrderAdditions,
  propagateOrderServiceOrderChanges,
  propagateOrderServiceOrderDeletions,
} from './mockData'
import type { IOrderMSService, IOrderServiceOrder } from '~/types/order/models'

interface GetServiceOrdersResponse {
  data: IOrderServiceOrder[]
}

async function getServiceOrders(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  console.log(`'Returning serviceOrders.`)
  const responseBody: GetServiceOrdersResponse = {
    data: await getOrderServiceOrderListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

interface GetOrderMSServicesForOrderServiceOrderIdResponse {
  data: IOrderMSService[]
}

async function getOrderMSServicesForOrderServiceOrderId(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  try {
    const responseBody: GetOrderMSServicesForOrderServiceOrderIdResponse = {
      data: await getMOMSSListDataByOrderServiceOrderId(id)!, // will either be valid or will have thrown error
    }
    return res(ctx.status(200), ctx.json(responseBody))
  } catch (e: unknown) {
    const responseBody = {
      statusCode: 404,
      message: `Can't get OrderServiceOrder ${id} OrderMSServices: ${e.message}`,
    }
    return res(ctx.status(404), ctx.json(responseBody))
  }
}

// post

const postOrder = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(
    req,
    res,
    ctx,
    getOrderServiceOrderListData,
    undefined,
    propagateOrderServiceOrderAdditions
  )
}

const patchOrder = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getOrderServiceOrderListData, [
    propagateOrderServiceOrderChanges,
  ])
}

const deleteOrder = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(
    req,
    res,
    ctx,
    getOrderServiceOrderListData,
    undefined,
    propagateOrderServiceOrderDeletions
  )
}

export const handlers = [
  {
    method: 'get',
    path: '/api/orderserviceorders',
    handler: getServiceOrders,
  },
  // {
  //   method: 'get',
  //   path: '/api/orderserviceorders:id/overview',
  //   handler: getOrderOverview_byId,
  // },
  {
    method: 'get',
    path: '/api/orderserviceorders/:id/ordermsservices',
    handler: getOrderMSServicesForOrderServiceOrderId,
  },
  {
    method: 'post',
    path: '/api/orderserviceorders',
    handler: postOrder,
  },
  {
    method: 'patch',
    path: '/api/orderserviceorders/:id',
    handler: patchOrder,
  },
  {
    method: 'delete',
    path: '/api/orderserviceorders/:id',
    handler: deleteOrder,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
